import PropTypes from "prop-types";
import React from "react";

import PageBody from "@components/PageBody";
import Report from "@components/Report";
import settings from "@settings/index";
import AdminPageTemplate from "@templates/AdminPage";

function SmsMoDr(props) {
  return (
    <AdminPageTemplate breadcrumbs={props.breadcrumbs}>
      <PageBody title="SMS - MO e DR (Dados Brutos)">
        <Report quickSightID={settings.reports.SMS_MO_DR} />
      </PageBody>
    </AdminPageTemplate>
  );
}

SmsMoDr.propTypes = {
  breadcrumbs: PropTypes.array,
};

SmsMoDr.defaultProps = {
  breadcrumbs: [],
};

export default SmsMoDr;
